// extracted by mini-css-extract-plugin
module.exports = {"title":"contentResponses_title__1JETj","body":"contentResponses_body__VxLDk","animateRoot":"contentResponses_animateRoot__32jVN"};